<template>
    <div>
        <h2>Servico</h2>
        
        <form @submit.prevent="submit">
            <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
                <input class="form__input" v-model.trim="$v.name.$model"/>
                <label class="form__label" :class="{'up': $v.name.$model }">Nome</label>
                <div class="error" v-if="!$v.name.required">Nome é obrigatório</div>
                <div class="error" v-if="!$v.name.minLength">Nome deve conter pelo menos {{$v.name.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.class.$error }">
                <input class="form__input" value="" v-model.trim="$v.class.$model"/>
                <label class="form__label" :class="{'up': $v.class.$model }">Classe (ícone)</label>
                <div class="error" v-if="!$v.class.required">Classe é obrigatória</div>
                <div class="error" v-if="!$v.class.minLength">Classe deve conter pelo menos {{$v.class.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" :class="{ 'form-group--error': $v.description.$error }">
                <trix-vue v-model="$v.description.$model"></trix-vue>
                <label class="form__label up">Descricrição</label>
                <div class="error" v-if="!$v.description.required">Descrição é obrigatório</div>
                <div class="error" v-if="!$v.description.minLength">Descrição deve conter pelo menos {{$v.description.$params.minLength.min}} caracteres.</div>
            </div>
            <div class="form-group" style="border: 1px solid #b5b5b5; border-radius: 3px; padding: 20px 0 5px 0; margin: 10px 0;">
                <label class="form__label up">Status</label>
                <div class="form-radio">
                    <input id="status_on" type="radio" v-model="status" :value="true">
                    <span></span>
                    <label for="status_on">Ativo</label>
                </div>
                <div class="form-radio">
                    <input id="status_off" type="radio" v-model="status" :value="false">
                    <span></span>
                    <label for="status_off">Desabilitado</label>
                </div>
                
            </div>
            
            
            


            
            <button class="button" type="submit" :disabled="submitStatus === 'PENDING' || $v.$invalid">Salvar</button>
            <button class="button white" type="button" @click="submit()">Descartar alterações</button>
            <!-- <p class="typo__p" v-if="submitStatus === 'OK'"></p> -->
            <p class="typo__p" v-if="submitStatus === 'ERROR'">Por favor, preencha todos os campos corretamente.</p>
            <p class="typo__p" v-if="submitStatus === 'PENDING'">Processando...</p>
        </form>
    </div>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators'
import TrixVue from '@dymantic/vue-trix-editor'
export default {
    name: "servicesForm",
    components: {
        TrixVue,
    },
    data(){
        return {
            openFiles: false,
            submitStatus: null,
            name: '',
            class: '',
            description: '',
            status: true,
            files: {
                images: []
            }
        }
    },
  
    validations: {
        name: {
            required,
            minLength: minLength(4)
        },
        class: {
            required,
            minLength: minLength(2)
        },
        description: {
            required,
            minLength: minLength(10)
        }
    },
    props: {
        service: {
            type: Object
        },
        callback: {
            type: Function
        }
    },
    mounted(){
        this.loadSnap()
        
        this.$v.$touch()

    },
    methods: {
        updateImage(img, index){
            
            this.files.images[index] = img
        },
        addImage(){
            this.files.images.push({})
        },
        loadSnap(){
            let keys = ['name', 'class', 'description', 'status']
            keys.forEach((key) => {
                this[key] = this.service[key]
            })
            this.files = this.service.files
        },
        submit() {
            console.log('submit!')
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
            } else {
            // do your submit logic here
            this.submitStatus = 'PENDING'
            setTimeout(() => {
              this.submitStatus = 'OK'
              this.save()
            }, 500)
            }
        },
        save(){
            let service = {
                name: this.name,
                class: this.class,
                status: this.status,
                description: this.description,
                lastUpdate: this.$moment().format('X')
            }
            if(this.service.docId){
                this.$db.collection("services").doc(this.service.docId).set(service).then(
                    result => {
                        if(result){
                            this.$root.updated = false
                            this.$root.alerts.push({msg: 'Serviço salvo com sucesso', type: 'success'})
                            this.callback()
                        }
                        
                    },
                    err => {
                        this.$root.updated = false
                        alert('Erro ao salvar: ' + err)
    
                    }
                );
            }
            else{
                this.$db.collection('services').add(service).then(() => {
                    this.$root.updated = false
                            this.$root.alerts.push({msg: 'Serviço salvo com sucesso', type: 'success'})
                            this.callback()
                }).catch((err) => {
                    alert('Erro ao salvar: ' + err)
                })
            }
        }
    }
} 
</script>